import React, { useState } from "react";
import SaveButton from "@/ui-controls/SaveButton";
import CancelButton from "@/ui-controls/CancelButton";
import { Grid } from "fluentui-react-grid";
import TextInput from "@/ui-controls/TextInput";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Role, addRole } from "@/api/roles";
import { Application } from "@/api/applications";

interface Props {
  application: Application;
  onSave?: (newRole: Role) => any;
  onClose?: () => any;
}

const NewAppRoleForm = (props: Props) => {
  const [isSaving, setIsSaving] = useState<boolean>(false);

  const onCancelForm = () => {
    if (props.onClose) props.onClose();
  };

  const saveRole = (role: Role) => {
    setIsSaving(true);

    addRole(role).then(
      (result) => {
        setIsSaving(false);
        let role = {
          ...result,
          PrivilegesCount: 0,
        };
        if (props.onSave) props.onSave(role);
      },
      (error) => {
        // Error handled by parent component
        setIsSaving(false);
      }
    );
  };

  const formik = useFormik({
    initialValues: { name: "", description: "", weight: 0 },
    validationSchema: Yup.object({
      name: Yup.string().required("Name is required").max(250),
      description: Yup.string().required("Description is required").max(250),
      weight: Yup.number().min(0).max(999),
    }),
    onSubmit: (values, { resetForm }) => {
      const role = {
        Name: values.name,
        Description: values.description,
        Weight: Number(values.weight),
        IsActive: true,
        ApplicationId: props.application.Id,
      } as Role;
      saveRole(role);
      resetForm({
        values: {
          name: "",
          description: "",
          weight: 0,
        },
      });
    },
  });

  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <Grid dir="ltr">
          <Grid.Row>
            <Grid.Col sizeSm={12}>
              <TextInput
                label="Name"
                baseTypeProps={{
                  disabled: isSaving,
                  ...formik.getFieldProps("name"),
                }}
                hasError={formik.errors.name && formik.touched.name}
                errorMessage={formik.errors.name}
              />
            </Grid.Col>
          </Grid.Row>
          <Grid.Row>
            <Grid.Col sizeSm={12}>
              <TextInput
                label="Description"
                baseTypeProps={{
                  disabled: isSaving,
                  ...formik.getFieldProps("description"),
                }}
                hasError={
                  formik.errors.description && formik.touched.description
                }
                errorMessage={formik.errors.description}
              />
            </Grid.Col>
          </Grid.Row>
          <Grid.Row>
            <Grid.Col sizeSm={12}>
              <TextInput
                label="Weight"
                baseTypeProps={{
                  disabled: isSaving,
                  ...formik.getFieldProps("weight"),
                }}
                hasError={formik.errors.weight && formik.touched.weight}
                errorMessage={formik.errors.weight}
              />
            </Grid.Col>
          </Grid.Row>
          <Grid.Row className="panel-buttons">
            <Grid.Col>
              <SaveButton
                text="Save"
                baseTypeProps={{ type: "submit", disabled: isSaving }}
              />
            </Grid.Col>
            <Grid.Col>
              <CancelButton
                text="Cancel"
                onClick={onCancelForm}
                baseTypeProps={{ disabled: isSaving }}
              />
            </Grid.Col>
          </Grid.Row>
        </Grid>
      </form>
    </>
  );
};

export default NewAppRoleForm;
